import React, { Component } from 'react';
import "./App.css"
import MobileDetect from 'mobile-detect'

import StickyFooter from './Comp/Shared/StickyFooter'
import LetGo from './Comp/LetGo'
import Sim from './Comp/Sim'
import Wellcome from './Comp/Wellcome'
import Wifi from './Comp/Wifi'
import Name from './Comp/Name'
import GoogleServices from './Comp/GoogleServices'
import AllSet from './Comp/AllSet'
import Done from './Comp/Done'
import Google_userName from './Comp/Google_userName'
import Google_pass from './Comp/Google_pass'
import Google_agree from './Comp/Google_agree'
import Assist_1 from './Comp/Assist_1'
import Assist_prem from './Comp/Assist_prem'
import Assist_prem_2 from './Comp/Assist_prem_2'
import Google_backup from './Comp/Google_backup'
import LetSimulate from './Comp/LetSimulate'
import GoogleBuildInApp from './Comp/GoogleBuildInApp'
import NotGoogleApps from './Comp/NotGoogleApps'
import AboutSimulation from './Comp/AboutSimulation'
import GoogleBuildInApp_delete from './Comp/GoogleBuildInApp_delete'

import PhoneType from './dComp/PhoneType'
import Gender from './dComp/Gender'
import Age from './dComp/Age'
import CountryWhereYouCurrentlyLive from './dComp/CountryWhereYouCurrentlyLive'
import HowLongHaveYouBeenAnAndroidUser from './dComp/HowLongHaveYouBeenAnAndroidUser'
import AndroidBasedDevicesHaveYouHad from './dComp/AndroidBasedDevicesHaveYouHad'
import HowLongAgoBuyCurrentSmartphone from './dComp/HowLongAgoBuyCurrentSmartphone'
import HowManyApps from './dComp/HowManyApps'
import EasyDownloadNewApps from './dComp/EasyDownloadNewApps'

import G_app from './gComp/G_app'
const uuidv4 = require('uuid/v4');
const myUid = uuidv4()
var md = new MobileDetect(window.navigator.userAgent);
global.isMobile = md.mobile()
global.isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

global.blue = "#1A73EB"
global.lightblue = "#519eff"
global.verylightblue = "#82b9ff"
global.serverUrl = "https://android-onboarding-result.herokuapp.com"
// global.serverUrl = "http://localhost:3650"
let tryInx = 0
function sendData() {
	// global._data.Logs = logArr
	global._data.uuid = myUid
	console.log(JSON.stringify(global._data, null,2))
	console.log("[+] SENDING ....")
	fetch(`${global.serverUrl}/submit/${global.groupName}`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify(global._data)
	}).then(respond => {
		console.log("respond: " + respond.statusText === "OK")
	}).catch(err => {
		console.log("Err:")
		console.log(err)
		tryInx++
		setTimeout(sendData,125 * tryInx)
	})
}

const startTime = new Date()
global.logAction = (action, param) => {
	const t = (new Date().getTime() - startTime.getTime())/1000
	fetch(`${global.serverUrl}/log`, {
		method: 'POST',
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({
			uuid: myUid,
			t,
			action,
			param,
		})
	}).then(respond => {
		console.log("respond: " + respond.statusText === "OK")
	}).catch(err => {
		console.log("Err:")
		console.log(err)
	})
	// console.log(JSON.stringify(logArr, null,2))
}
global.logAction(`Start`,startTime)


global._data = {}

global.setAnswer = (k, v, force) => {
	if(force || (global._data[k] !== undefined && global._data[k] !== v)){
		global.logAction(k,v)
	}
	global._data[k] = v
	// console.log(`${k} => ${v}`)
	// console.log(JSON.stringify(global._data, null,2))
}



class App extends Component {
	state = {
		language: "EN",
		winWidth:1000,
		winHeight:800,
		pos:0,
		steps: {
			demographics: [
				{cmp:Gender},
				{cmp:Age},
				{cmp:CountryWhereYouCurrentlyLive},
				{cmp:HowLongHaveYouBeenAnAndroidUser},
				{cmp:AndroidBasedDevicesHaveYouHad},
				{cmp:HowLongAgoBuyCurrentSmartphone},
				{cmp:HowManyApps},
				{cmp:EasyDownloadNewApps},
			],
			group_a : [
				// {cmp:LetGo},
				{cmp:LetSimulate, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:PhoneType, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				{cmp:AboutSimulation, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Wellcome, props:{showFooter:false, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_userName, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_pass, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_agree, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Assist_1, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Assist_prem_2, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:Name, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:GoogleServices, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'agree' }},
				// {cmp:Google_backup, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:GoogleBuildInApp, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'next' }},
				{cmp:NotGoogleApps, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'next' }},
				{cmp:AllSet, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Age, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Gender, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				// {cmp:HowLongHaveYouBeenAnAndroidUser, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:AndroidBasedDevicesHaveYouHad, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:CountryWhereYouCurrentlyLive, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				// {cmp:HowLongAgoBuyCurrentSmartphone, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:HowManyApps, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:EasyDownloadNewApps, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:G_app, props:{k:"Chrome", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google maps", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Calendar",showFooter:true , isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"YouTube", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Search", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Docs", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:Done, props:{showFooter:false, isScrolling:false, isValid:true, buttonName:'next' }},
			],
			group_b: [
				// {cmp:LetGo},
				{cmp:LetSimulate, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:PhoneType, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				{cmp:AboutSimulation, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Wellcome, props:{showFooter:false, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_userName, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_pass, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Google_agree, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Assist_1, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Assist_prem_2, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:Name, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:GoogleServices, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'agree' }},
				// {cmp:Google_backup, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:GoogleBuildInApp_delete, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'next' }},
				{cmp:NotGoogleApps, props:{showFooter:true, isScrolling:true, isValid:true, buttonName:'next' }},
				{cmp:AllSet, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Age, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:Gender, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				// {cmp:HowLongHaveYouBeenAnAndroidUser, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:AndroidBasedDevicesHaveYouHad, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:CountryWhereYouCurrentlyLive, props:{showFooter:true, isScrolling:false, isValid:false, buttonName:'next' }},
				// {cmp:HowLongAgoBuyCurrentSmartphone, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:HowManyApps, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				// {cmp:EasyDownloadNewApps, props:{showFooter:true, isScrolling:false, isValid:true, buttonName:'next' }},
				{cmp:G_app, props:{k:"Chrome", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google maps", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Calendar",showFooter:true , isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"YouTube", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Search", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:G_app, props:{k:"Google Docs", showFooter:true, isScrolling:true, isValid:false, buttonName:'next' }},
				{cmp:Done, props:{showFooter:false, isScrolling:false, isValid:true, buttonName:'next' }},
			]
		}
	}
	constructor(props) {
		super(props)
		
		global.setValid = (valid) => {
			let stage = this.state.steps[global.groupName][this.state.pos];
			stage.props.isValid = valid;
			this.setState({stage})
		}
		global.setLanguage = (lan) => {
			// console.log("set to: " + lan);
			this.setState({language: lan});
		}
	}
	componentDidMount() {
		// window.location = '#group_a/0'
		window.onhashchange = () => this.Nav()
		global.nextStage = (stage = undefined) => {
			window.location = `#${this.state.pos + 1}`;
			// window.location = `#${global.groupName}/${this.state.pos + 1}`;
		} 
		window.addEventListener("resize", this.updateDimensions.bind(this));
		this.updateDimensions()
		this.Nav()
	}
	updateDimensions() {
		this.setState({
			winHeight: window.innerHeight,
			winWidth: window.innerWidth,			
		})
	}
	Nav() {
		const {hash} = window.location
		if(!global.groupName) {
			const coin = Math.floor(Math.random() * 2)
			if(coin) {
				global.groupName = 'group_a'
			} else {
				global.groupName = 'group_b'
			}
			global.setAnswer("group", global.groupName)
			// window.location = `#${global.groupName}/0`
			
			window.location = `#0`
			return
			// alert("adaf: " + coin)
		}
		const sp = hash.substr(1).split('/')
		// if(!global.groupName) {
		// 	global.groupName = sp[0]
		// 	global.setAnswer("group", global.groupName)
		// }
		const nextPos = Number(sp[0])
		if(nextPos <= this.state.pos) return;
		//
		this.setState({pos:nextPos})
		global.logAction(`screen`,nextPos)
		this.divRef && this.divRef.scrollTo(0,0)
		const steps = this.state.steps[global.groupName]
		if(nextPos === steps.length - 1) {
			!global._dataSent && sendData()
			global._dataSent = true
		}
	}
	render() {
		const {winHeight, winWidth, pos} = this.state;
		if(!global.groupName) return null
		const steps = this.state.steps[global.groupName]
		// console.log(`pos = ${pos}`)
		// console.log(`steps = ${steps}`)
		const H = 640
		const W = 360
		const scale = global.isMobile ? winWidth / W : 1

		const topMargin = global.isMobile ? 0 : (winHeight - H)/2
		const leftMargin = (winWidth - W)/2

		const Cmp = steps[pos]
		return (
			<div style={{
				position:"absolute",
				top:0,
				left:0,
				width: winWidth,
				height: winHeight,
				overflow:"hidden",
				boxSizing: "border-box",
				userSelect: "none",	
			}}>
				<div id="container" style={{
					position:"absolute",
					zIndex: 2,
					transformOrigin: "top center",
					transform:"scale(" + scale + ")",
					top: topMargin,
					left:leftMargin,
					width:W,
					height:H,
					outline: global.isMobile ? '' : '2px solid black',
					// backgroundColor:"rgba(0,255,0,0.3)",
					overflowY: this.state.steps[global.groupName][this.state.pos].props.isScrolling ? "scroll": "auto",
					overflowX:"hidden"	
				}} ref={r => this.divRef = r}>
					{steps.map((_,i) => {
						// console.log(_)
					return <div style={{
						display:i===pos ? "" : "none"
					}}> 
						<_.cmp {..._.props} t={topMargin} l={leftMargin} W={W} H={H} language={this.state.language}/>
					</div>})}
				</div>	
							
				<StickyFooter 
					pos={pos}
					showFooter={this.state.steps[global.groupName][this.state.pos].props.showFooter}
					isScrolling={this.state.steps[global.groupName][this.state.pos].props.isScrolling}
					isValid={this.state.steps[global.groupName][this.state.pos].props.isValid} 
					buttonName={this.state.steps[global.groupName][this.state.pos].props.buttonName} 
					style={{
						position: "absolute",
						width: global.isMobile ? winWidth : W,
						left: global.isMobile ? "auto" : leftMargin,
						bottom: global.isMobile ? 0 : (winHeight - H)/2,
				}}/>
				
			</div>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js